import { render } from "./ErrorQr.vue?vue&type=template&id=39229402"
import script from "./ErrorQr.vue?vue&type=script&lang=js"
export * from "./ErrorQr.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__